import { AbstractService } from '../../shared/services/abstract.service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PaymentService extends AbstractService {
  async cancelSubscription(): Promise<void> {
    await this.http.delete(`${this.apiBaseUrl}/payment/`).toPromise();
  }

  async subscribeForFree(email: string): Promise<void> {
    await this.http.post(`${this.apiBaseUrl}/payment/free`, { email }).toPromise();
  }

  async subscribeWithInvoice(email: string): Promise<void> {
    await this.http.post(`${this.apiBaseUrl}/payment/invoice`, { email }).toPromise();
  }

  async reactivateSubscription(): Promise<void> {
    await this.http.post(`${this.apiBaseUrl}/payment/reactivate`, {}).toPromise();
  }
}
